import React from 'react';
import './Spinner.css';

const Spinner: React.FC = () => {
    return <div className={'loader'}>Loading...</div>;
};

export default Spinner;
